import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from 'react-i18next';

const SpinCount = ({ memberEligibleSpin }) => {
    const { t } = useTranslation(['luckyWheel']);
    return (
        <div className='spin-count-container'>
            <p className='spin-count-text'>{t('luckyWheel.spinAvaialble', { count: memberEligibleSpin })}</p>
            <LazyLoadImage src='/public/html/images/lucky-wheel/spin-avai-bar.png' className='spin-count-bg' alt='spin-available' />
            <LazyLoadImage src='/public/html/images/lucky-wheel/lucky-wheel-bottom.gif' className='lucky-wheel-btm-img' alt='bottom-img' />
        </div>
    );
};

export default SpinCount;
